<template>
  <div>
    <b-modal
      ref="modal"
      id="modal-no-backdrop"
      hide-backdrop
      content-class="shadow"
      :title="'Confirma o cancelamento da compra?'"
    >
      <div class="container-fluid">
        <div class="row"></div>
        <br />
        <div class="row">
          <div class="col-12">
            <h3>Compra #{{ purchase.number }}</h3>
          </div>
        </div>
        <br />
      </div>

      <div slot="modal-footer">
        <button
          role="button"
          class="btn btn-outline-secondary"
          @click="$refs.modal.hide()"
        >
          <i class="fas fa-times"></i> Não Cancelar
        </button>
        <button
          role="button"
          class="btn btn-danger"
          style="margin-left: 5px"
          @click="store()"
        >
          <i class="fas fa-check"></i> Cancelar
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>


export default {
  data: function () {
    return {
      purchase: {},
    };
  },

  methods: {
    open(purchase) {
      this.purchase = purchase;
      this.$refs.modal.show();
    },

    async store() {
      this.$store.commit("showLoading");
      
      await this.$store.dispatch('purchase/deletePurchase', this.purchase.id).then(response => {
        this.$refs.modal.hide();
        this.$emit('store');
      })
      
      this.$store.commit("hideLoading");
    },
  },
};
</script>

<style>
</style>